import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 5,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderBottomColor: '#004899',
        backgroundColor: '#ffffff',
    },
    projectIdContainer: {
        backgroundColor: '#f0f5ff',
        padding: 6,
        borderRadius: 4,
        borderLeftWidth: 2,
        borderLeftColor: '#004899',
    },
    projectIdLabel: {
        color: '#666',
        fontSize: 8,
        fontWeight: 'bold',
    },
    projectIdValue: {
        color: '#004899',
        fontSize: 10,
        fontWeight: 'bold',
    },
    pageTitle: {
        color: '#004899',
        fontSize: 16,
        fontWeight: 'bold',
    },
    confidentialText: {
        color: '#FF0000',
        fontSize: 8,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 10,
        fontStyle: 'italic',
    },
});

interface StandardHeaderProps {
    projectId: string;
    createdAt: string;
    title: string;
    isDa?: boolean;
}

export const StandardHeader: React.FC<StandardHeaderProps> = ({ projectId, createdAt, title,isDa=false }) => {
    const date = new Date(createdAt);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const formattedId = isDa? `${year}${month}-DA${projectId}` : `${year}${month}-PT${projectId}`;

    return (
        <>
            <View style={styles.headerContainer}>
                <View style={styles.projectIdContainer}>
                    <Text style={styles.projectIdLabel}>Project ID</Text>
                    <Text style={styles.projectIdValue}>{formattedId}</Text>
                </View>
                <Text style={styles.pageTitle}>{title}</Text>
            </View>
            {/* <Text style={styles.confidentialText}>PRIVILEGED AND CONFIDENTIAL - PROPERTY OF PEPSICO, INC.</Text> */}
        </>
    );
}; 